/**
 * Visits API Endpoints
 * Centralized endpoint definitions for visit-related operations.
 */
export const VISITS_ENDPOINTS = {
  /**
   * Get visits (paginated)
   * @method GET
   * @endpoint /visits
   * @query {number} pageNumber - Page number (default: 1)
   * @query {number} pageSize - Items per page (default: 10)
   * @query {string} filter - FQL filter
   */
  LIST: "/visits",

  /**
   * Get visit results
   * @method GET
   * @endpoint /visits/{id}/results
   * @param {number} id - Visit ID
   */
  RESULTS: (id: number) => `/visits/${id}/results`,

  /**
   * Get visit balance
   * @method GET
   * @endpoint /visits/{id}/balance
   * @param {number} id - Visit ID
   */
  BALANCE: (id: number) => `/visits/${id}/balance`,

  /**
   * Download visit results as PDF
   * @method GET
   * @endpoint /visits/{id}/pdf
   * @param {number} id - Visit ID
   */
  PDF: (id: number) => `/visits/${id}/pdf`,
} as const;
